import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
/** Preserves query string when sending verify-email links into the app. */
const VerifyEmailRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/app/verify-email${search}`} replace />;
};

export default VerifyEmailRedirect;
